import { getPbgidIcon, usePbgidIcons } from '../../helpers/pbgidIcons'

function getMaliIconByPbgid(_pbgid) {
	if (_pbgid === 9000375) {
		return '/liveGameIcons/unique/mali/musofadi_farimba.png'
	}
	if (_pbgid === 9000508) {
		return '/liveGameIcons/unique/mali/musofadi_farimba.png'
	}
	if (_pbgid === 9000376) {
		return '/liveGameIcons/unique/mali/javelin_thrower_mansa.png'
	}
	if (_pbgid === 9000509) {
		return '/liveGameIcons/unique/mali/javelin_thrower_mansa.png'
	}
	if (_pbgid === 9000377) {
		return '/liveGameIcons/unique/mali/musofadi_mansa.png'
	}
	if (_pbgid === 9000510) {
		return '/liveGameIcons/unique/mali/musofadi_mansa.png'
	}
	return null // not found
}

export function LiveGameTechDisplay({ pbg_id, hasTech, isUnique = false }) {
	const pbgidIcons = usePbgidIcons()

	if (pbg_id === 'gapper') {
		return <div className="w-10 h-10"></div>
	}

	pbg_id = parseInt(pbg_id)

	let background = pbg_id ? `/liveGameIcons/tech_background.png` : `/liveGameIcons/empty_background.png`
	let icon = getPbgidIcon(pbgidIcons, pbg_id) || getMaliIconByPbgid(pbg_id) || '/liveGameIcons/unknown.png'

	return (
		<div
			className="w-10 h-10 border-solid-1"
			style={{
				backgroundImage: `url(${background})`,
				borderColor: 'var(--main-color)',
				filter: !hasTech && 'brightness(40%)',
			}}>
			{icon && <img src={icon} alt="" />}
			{isUnique && <img className="absolute bottom-0 left-0 w-4 h-4" src={`/liveGameIcons/unique.png`} alt="" />}
		</div>
	)
}
